export interface IApplicationState {

    showSettingPanelForMobile: boolean;
    openScreen: string;


}

const initialState: IApplicationState = {
    showSettingPanelForMobile: false,
    openScreen: "",


};

export enum actionTypes {

    SHOW_SETTING_PANEL_FOR_MOBILE = '@@winShower/SHOW_SETTING_PANEL_FOR_MOBILE',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { showSettingPanelForMobile, openScreen } = action;

    switch (action.type) {
        case actionTypes.SHOW_SETTING_PANEL_FOR_MOBILE:
            return {
                ...state, showSettingPanelForMobile: showSettingPanelForMobile, openScreen: openScreen,
            };
        default:
            return state;
    }
}

export const actions = {
    showSettingPanelContainerForMobile: (showSettingPanelForMobile: boolean, openScreen: string): any => ({
        type: actionTypes.SHOW_SETTING_PANEL_FOR_MOBILE,
        showSettingPanelForMobile, openScreen
    }),



};
